module.exports = __webpack_public_path__ + "img/commerce_icon.1b328c33.svg";